import { render, staticRenderFns } from "./SceneNameDialog.vue?vue&type=template&id=3bac2e08&scoped=true"
import script from "./SceneNameDialog.vue?vue&type=script&lang=js"
export * from "./SceneNameDialog.vue?vue&type=script&lang=js"
import style0 from "./SceneNameDialog.vue?vue&type=style&index=0&id=3bac2e08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac2e08",
  null
  
)

export default component.exports